<div class="">
   <div class="contentBox">
      <ul class="brand-details-list team-list looking-for-list font-16 line-25">
         <li class="no-border">
            <div class="person-pic wow fadeInUp"
                 data-wow-duration="500ms" data-wow-delay="50ms">
               <div class="icon pic width-180">
                  <img src="assets/images/trophy.png" alt="">
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 proximaNovaSb font-18 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Leadership
               </div>
               <ul class="points no-dots looking-for wow fadeInUp"
                   data-wow-duration="500ms" data-wow-delay="150ms">
                  <li>Only work with people we Like, Admire, and Trust</li>
                  <li>High Integrity and deep Intellectual Honesty</li>
                  <li>Strong Drive and Passion to overcome all obstacles</li>
                  <li>Full Alignment and the right long-term Attitude</li>
                  <li>Ability to Motivate, and Nurture talented leadership (it takes a village to run a business)
                  </li>
               </ul>
            </div>
         </li>
         <li class="">
            <div class="person-pic">
               <div class="icon pic width-180 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/good-trends.png" alt="">
               </div>
            </div>
            <div class="person-details line-25">
               <div class="margin-b-15 proximaNovaSb font-18 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  Business Quality and Opportunity
               </div>
               <ul class="points no-dots looking-for wow fadeInUp"
                   data-wow-duration="500ms" data-wow-delay="150ms">
                  <li>Long runway of growth, and increasing avenues as new TAMs open up</li>
                  <li>Right side of disruption and change (so that these are tailwinds, and not headwinds)</li>
                  <li>Great economic model on maturity and low capital intensity to get there (relative to size of
                     the prize)
                  </li>
                  <li>Leadership position (or the capabilities and desire to get into leadership position)</li>
                  <li>High returns on capital and low leverage so that the returns are not generated by financial
                     engineering but by business value creation
                  </li>
               </ul>
            </div>
         </li>
         <li class="">
            <div class="person-pic">
               <div class="icon pic width-180 wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="50ms">
                  <img src="assets/images/cash-dollar.png" alt="">
               </div>
            </div>
            <div class="person-details line-25 wow fadeInUp"
                 data-wow-duration="500ms" data-wow-delay="150ms">
               <div class="margin-b-15 proximaNovaSb font-18">
                  Reasonable Entry Valuation
               </div>
               <ul class="points no-dots looking-for wow fadeInUp"
                   data-wow-duration="500ms" data-wow-delay="150ms">
                  <li>Valuations are inherently volatile and uncertain, so we don’t aim for false precision</li>
                  <li>Our desire is to be correct in direction and magnitude, and also whether the Leader, Business,
                     and our Partnership characteristics have the ingredients and key success factors to achieve
                     great outcomes
                  </li>
                  <li>Time should be a friend and not an enemy – the business should improve its market position,
                     competitive standing, and leadership even during lean times. We want the magic of compounding to
                     work in our favor
                  </li>
               </ul>
            </div>
         </li>
      </ul>
   </div>
</div>
